import { render, staticRenderFns } from "./FigmaPreview.vue?vue&type=template&id=d1f57d94"
import script from "./FigmaPreview.vue?vue&type=script&lang=js"
export * from "./FigmaPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1f57d94')) {
      api.createRecord('d1f57d94', component.options)
    } else {
      api.reload('d1f57d94', component.options)
    }
    module.hot.accept("./FigmaPreview.vue?vue&type=template&id=d1f57d94", function () {
      api.rerender('d1f57d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/figma-layers/FigmaPreview.vue"
export default component.exports